import styled from "@emotion/native";
import { Platform, ViewStyle } from "react-native";
import { AboutScienceSafety } from "myplan/components/Icon";
import Text from "myplan/components/Text";
import * as drawer from "myplan/utils/drawer";

export const Container = styled.SafeAreaView({
    flex: 1,
});

export const DrawerButtonContainer = styled.View({
    position: "absolute",
    width: 60,
    height: 60,
    left: 12,
    top: 40,
    zIndex: 10,
    alignItems: "center",
    justifyContent: "center",
});

export const BackButtonContainer = styled.View({
    position: "absolute",
    width: 60,
    height: 60,
    top: 40,
    right: 20,
    zIndex: 10,
    alignItems: "center",
    justifyContent: "center",
});

export const Scroll = styled.ScrollView({
    // paddingTop: 60,
    overflow: Platform.OS === ("android" || "web") ? "scroll" : "visible",
    paddingHorizontal: 20,
    marginBottom: drawer.BUTTON_HEIGHT + drawer.MARGIN_BOTTOM,
});

Scroll.defaultProps = {
    contentContainerStyle: {
        flexGrow: 1,
    },
};

export const Header = styled(Text)(
    {
        marginTop: 35 + drawer.BUTTON_HEIGHT,
        marginBottom: 0,
    },
    ({ theme }: any) => {
        let style: ViewStyle = {};

        // if (theme.verticalScale < 1) {
        //     const buttonTop = drawer.BUTTON_TOP * theme.verticalScale;
        //     const buttonHeight = drawer.BUTTON_HEIGHT * theme.verticalScale;
        //     const marginBottom = drawer.MARGIN_BOTTOM * theme.verticalScale;
        //     const marginTop = buttonTop + buttonHeight + marginBottom;

        //     style = {
        //         marginTop,
        //     };
        // }

        return style;
    },
);

export const ImageContainer = styled.View({
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
});

export const Hero = styled(AboutScienceSafety)({
    maxWidth: 250,
    width: "50%",
});
